document.addEventListener('DOMContentLoaded', async () => {
  const wrappers = document.querySelectorAll('[id^="inline-stars-wrapper-"]');

  for (const wrapper of wrappers) {
    const productId = wrapper.dataset.productId;
    const starContainer = wrapper.querySelector('.inline-stars');
    if (!productId || !starContainer) continue;

    try {
      const res = await fetch(`https://dakhli-reviews-application.fly.dev/product/${productId}/rating`);
      const data = await res.json();
      const rating = data.rating || 0;

      if (rating === 0) {
        wrapper.style.display = 'none';
        continue;
      }

      let starsHTML = '';
      for (let i = 0; i < 5; i++) {
        if (i < Math.floor(rating)) {
          starsHTML += '<span class="inline-star filled">★</span>';
        } else if (i < rating) {
          const fillWidth = (rating - i) * 100;
          starsHTML += `<span class="inline-star partial" style="--fill-width: ${fillWidth}%">★</span>`;
        } else {
          starsHTML += '<span class="inline-star">★</span>';
        }
      }

      starContainer.innerHTML = starsHTML;
      wrapper.style.display = 'flex';
      wrapper.style.visibility = 'visible';
    } catch (e) {
      console.error('Failed to load inline stars:', e);
    }
  }

  if (window.location.href.includes('/products/')) {
    const style = document.createElement('style');
    style.innerHTML = `
      .inline-stars-wrapper {
        margin-top: 13px !important;
        margin-bottom: -5px !important;
      }
    `;
    document.head.appendChild(style);
  }
});
